/* ============================================================
   Pixel Potion — scripts propios (vanilla, sin librerías)
   ============================================================ */
(function () {
  "use strict";

  // Guard de ejecución única: la misma etiqueta <script> aparece en varias
  // secciones y el navegador ejecuta cada una.
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveals al hacer scroll ---------- */
  var observer = null;
  function initReveals() {
    var els = document.querySelectorAll(".mt-reveal:not([data-mt-rev])");
    if (!els.length) return;
    if (reduce) {
      els.forEach(function (el) {
        el.dataset.mtRev = "1";
        el.classList.add("mt-visible");
      });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add("mt-visible");
              observer.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
    }
    els.forEach(function (el, i) {
      el.dataset.mtRev = "1";
      if (!el.style.transitionDelay) {
        el.style.transitionDelay = (i % 6) * 90 + "ms";
      }
      observer.observe(el);
    });
  }

  /* ---------- 1. Héroe spotlight: el foco sigue al cursor ---------- */
  function initHeroFoco() {
    document.querySelectorAll(".mt-hero").forEach(function (hero) {
      if (hero.dataset.mtInit) return;
      hero.dataset.mtInit = "1";
      var foco = hero.querySelector(".mt-hero-foco");
      if (!foco || reduce) return;
      if (window.matchMedia("(hover: none)").matches) return;
      var raf = null;
      hero.addEventListener("mousemove", function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var r = hero.getBoundingClientRect();
          var x = ((ev.clientX - r.left) / r.width) * 100;
          var y = ((ev.clientY - r.top) / r.height) * 100;
          foco.style.setProperty("--mt-x", x.toFixed(1) + "%");
          foco.style.setProperty("--mt-y", y.toFixed(1) + "%");
        });
      });
      hero.addEventListener("mouseleave", function () {
        foco.style.removeProperty("--mt-x");
        foco.style.removeProperty("--mt-y");
      });
    });
  }

  /* ---------- 2. Marquesinas: duplicar contenido para bucle infinito ---------- */
  function initMarquesinas() {
    document.querySelectorAll(".mt-marq-fila").forEach(function (fila) {
      if (fila.dataset.mtInit) return;
      fila.dataset.mtInit = "1";
      var pista = fila.querySelector(".mt-marq-pista");
      if (!pista) return;
      // duplicamos hasta cubrir el doble del ancho de la ventana
      var copia = pista.cloneNode(true);
      copia.setAttribute("aria-hidden", "true");
      fila.appendChild(copia);
    });
  }

  /* ---------- 3. Configurador de 7 colores ---------- */
  function initColores() {
    document.querySelectorAll(".mt-colores").forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = "1";
      var botones = sec.querySelectorAll(".mt-sw");
      var fotos = sec.querySelectorAll(".mt-col-fotos img");
      var nombre = sec.querySelector(".mt-col-nombre");
      if (!botones.length) return;

      function activar(i) {
        botones.forEach(function (b, j) {
          b.setAttribute("aria-pressed", j === i ? "true" : "false");
        });
        fotos.forEach(function (f, j) {
          f.classList.toggle("mt-on", j === i);
        });
        var color = botones[i].dataset.color || "#22D3EE";
        sec.style.setProperty("--mt-activo", color);
        if (nombre) nombre.textContent = botones[i].dataset.nombre || "";
      }

      botones.forEach(function (b, i) {
        b.addEventListener("click", function () { activar(i); });
        b.addEventListener("keydown", function (ev) {
          if (ev.key === "ArrowRight" || ev.key === "ArrowLeft") {
            ev.preventDefault();
            var n = ev.key === "ArrowRight" ? i + 1 : i - 1;
            if (n < 0) n = botones.length - 1;
            if (n >= botones.length) n = 0;
            botones[n].focus();
            activar(n);
          }
        });
      });
      activar(0);
    });
  }

  /* ---------- 4. FAQ ---------- */
  function initFaq() {
    document.querySelectorAll(".mt-faq-item").forEach(function (item) {
      if (item.dataset.mtInit) return;
      item.dataset.mtInit = "1";
      var btn = item.querySelector(".mt-faq-q");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var abierto = item.classList.contains("mt-abierto");
        var padre = item.closest(".mt-faq");
        if (padre) {
          padre.querySelectorAll(".mt-faq-item.mt-abierto").forEach(function (o) {
            if (o !== item) {
              o.classList.remove("mt-abierto");
              var b = o.querySelector(".mt-faq-q");
              if (b) b.setAttribute("aria-expanded", "false");
            }
          });
        }
        item.classList.toggle("mt-abierto", !abierto);
        btn.setAttribute("aria-expanded", String(!abierto));
      });
    });
  }

  /* ---------- 5. Galería de la página de producto (fotos + vídeo) ---------- */
  function initGaleria() {
    document.querySelectorAll(".mt-prod-galeria").forEach(function (gal) {
      if (gal.dataset.mtInit) return;
      gal.dataset.mtInit = "1";
      var slides = gal.querySelectorAll(".mt-prod-slide");
      var minis = gal.querySelectorAll(".mt-prod-mini");
      if (!slides.length) return;

      function activar(i) {
        slides.forEach(function (s, j) {
          var on = j === i;
          s.classList.toggle("mt-on", on);
          s.setAttribute("aria-hidden", on ? "false" : "true");
          var v = s.querySelector("video");
          if (!v) return;
          if (on) {
            v.muted = true;
            v.loop = true;
            v.playsInline = true;
            v.setAttribute("playsinline", "");
            if (reduce) {
              v.controls = true; // con movimiento reducido: no arranca solo
            } else {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else {
            v.pause();
          }
        });
        minis.forEach(function (m, j) {
          m.setAttribute("aria-pressed", j === i ? "true" : "false");
        });
      }

      minis.forEach(function (m, i) {
        m.addEventListener("click", function () { activar(i); });
      });
      activar(0);
    });
  }

  /* ---------- 6. Selector de pack en la página de producto ---------- */
  function initPacks() {
    document.querySelectorAll(".mt-packs").forEach(function (cont) {
      if (cont.dataset.mtInit) return;
      cont.dataset.mtInit = "1";
      var opciones = cont.querySelectorAll(".mt-pack");
      var input = document.getElementById(cont.dataset.target);
      var precioAhora = document.querySelector(".mt-prod-precio .mt-precio-ahora");
      var precioAntes = document.querySelector(".mt-prod-precio .mt-precio-antes");
      if (!opciones.length) return;
      opciones.forEach(function (op) {
        op.addEventListener("click", function () {
          opciones.forEach(function (o) { o.setAttribute("aria-pressed", "false"); });
          op.setAttribute("aria-pressed", "true");
          if (input) {
            input.value = op.dataset.variante;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
          if (precioAhora && op.dataset.precio) precioAhora.textContent = op.dataset.precio;
          if (precioAntes && op.dataset.antes) precioAntes.textContent = op.dataset.antes;
        });
      });
    });
  }

  /* ---------- 7. Pasos con vídeo real ---------- */
  function initPasosVideo() {
    document.querySelectorAll(".mt-pv").forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = "1";
      var auto = sec.dataset.autoplay !== "false" && !reduce;
      var medias = sec.querySelectorAll(".mt-pv-media");

      function silenciarTodos() {
        document.querySelectorAll(".mt-pv-media").forEach(function (om) {
          var ov = om.querySelector("video");
          var ob = om.querySelector(".mt-pv-sonido");
          if (ov) ov.muted = true;
          if (ob) {
            ob.setAttribute("aria-pressed", "false");
            ob.setAttribute("aria-label", "Activar sonido");
            ob.querySelector("span").textContent = "🔇";
          }
        });
      }
      function reproducir(m, v) {
        var p = v.play();
        m.classList.remove("mt-pausado");
        if (p && p.catch) p.catch(function () { m.classList.add("mt-pausado"); });
      }

      medias.forEach(function (m) {
        var v = m.querySelector("video");
        if (!v) return;
        // autoplay en navegadores exige vídeo silenciado e inline
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute("playsinline", "");
        v.removeAttribute("controls");
        if (!auto) m.classList.add("mt-pausado");

        var play = m.querySelector(".mt-pv-play");
        var snd = m.querySelector(".mt-pv-sonido");

        if (play) play.addEventListener("click", function () {
          m.dataset.pausaManual = "";
          reproducir(m, v);
        });
        v.addEventListener("click", function () {
          if (v.paused) { m.dataset.pausaManual = ""; reproducir(m, v); }
          else { v.pause(); m.classList.add("mt-pausado"); m.dataset.pausaManual = "1"; }
        });
        if (snd) snd.addEventListener("click", function () {
          var quiereSonido = v.muted;
          silenciarTodos(); // solo un vídeo con sonido a la vez
          if (quiereSonido) {
            v.muted = false;
            snd.setAttribute("aria-pressed", "true");
            snd.setAttribute("aria-label", "Silenciar");
            snd.querySelector("span").textContent = "🔊";
            m.dataset.pausaManual = "";
            reproducir(m, v);
          }
        });
      });

      // reproducir solo lo que se ve; pausar lo que sale de pantalla
      if (auto && "IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var m = e.target;
            var v = m.querySelector("video");
            if (!v) return;
            if (e.isIntersecting) {
              if (m.dataset.pausaManual !== "1") reproducir(m, v);
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.35 });
        medias.forEach(function (m) { io.observe(m); });
      }
    });

    // Chrome pausa los vídeos silenciados cuando la pestaña queda oculta.
    // Al volver a la pestaña, reanudamos los que están a la vista (salvo los
    // que el visitante pausó a propósito). Un solo listener para toda la página.
    if (!reduce && !window.__mtPvVis) {
      window.__mtPvVis = true;
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState !== "visible") return;
        document.querySelectorAll(".mt-pv").forEach(function (s) {
          if (s.dataset.autoplay === "false") return;
          s.querySelectorAll(".mt-pv-media").forEach(function (m) {
            var v = m.querySelector("video");
            if (!v || m.dataset.pausaManual === "1") return;
            var r = m.getBoundingClientRect();
            if (r.bottom > 0 && r.top < window.innerHeight && v.paused) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            }
          });
        });
        // y el vídeo activo de la galería del producto
        document.querySelectorAll(".mt-prod-slide.mt-on video").forEach(function (v) {
          if (v.paused && !v.controls) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        });
      });
    }
  }

  /* ---------- Arranque ---------- */
  function initTodo() {
    initReveals();
    initHeroFoco();
    initMarquesinas();
    initColores();
    initFaq();
    initGaleria();
    initPacks();
    initPasosVideo();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTodo);
  } else {
    initTodo();
  }
  // El editor de Shopify re-renderiza secciones sin recargar la página
  document.addEventListener("shopify:section:load", initTodo);
})();
